module.exports = __webpack_public_path__ + "static/AboutPckitUp-52fc82085da991e7af956b213846e527.mp4";